import React from "react";
import styled from "@emotion/styled";
import { constants } from "@services";
import { Box, Text, SearchIcon } from "@atoms";

// == Types ================================================================

interface IProps {
  onTouch: () => void;
}

// == Constants ============================================================

// == Component ============================================================

const OpenSearchBar = ({ onTouch }: IProps) => {
  return (
    <Box position="relative" width="100%">
      <EText color="primary">
        <SearchIcon />
      </EText>
      <EFakeInput
        border="1px solid #ccc"
        borderRadius="5px"
        boxShadow="none"
        fontSize="1rem"
        height="60px"
        lineHeight="60px"
        marginBottom={0}
        padding="0 20px 0 40px"
        width="100%"
        onClick={onTouch}
      >
        <Text color="gray">{constants.SEARCH_PLACEHOLER}</Text>
      </EFakeInput>
    </Box>
  );
};

export default OpenSearchBar;

// == Styles ===============================================================

const EText = styled(Text)`
  position: absolute;
  left: 16px;
  top: 22px;
`;

const EFakeInput = styled(Box)`
  cursor: pointer;
`;
